/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import LineChart from '../../../component/Inc/LineChart';
import Tab from '../../../component/Inc/Tab';
import 'contents/assets/scss/page/teacher.scss';
function TeacherClassInfo() {
  const [tabIdx, setTabIdx] = useState(0);
  const [tabCurrentIdx, setTabCurrentIdx] = useState(0);
  const [tabPrevIdx, setTabPrevIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '대면', value: 1},
    {title: '화상', value: 2}
  ];
  const tabCurrent = [
    {title: '전체', value: 0},
    {title: '준비', value: 1},
    {title: '첫수업', value: 2},
    {title: '수업중', value: 3}
  ];
  const tabPrev = [
    {title: '전체', value: 0},
    {title: '인계', value: 1},
    {title: '중단', value: 2},
    {title: '종료', value: 3}
  ];
  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  //연간 평균 타임수
  const yearlabels = ['2019', '2020', '2021', '2022', '2023', '2024'];
  const data = {
    lineChartlabels: yearlabels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [10000, 20000, 40000, 20000, 50000],
        backgroundColor: '#3780ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      },
      {
        label: 'Dataset 2',
        data: [5000, 40000, 20000, 30000, 50000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //월간 평균 타임수
  const monthlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const dataMonth = {
    lineChartlabels: monthlabels,
    datasets: [
      {
        label: 'Dataset 2',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#ef3a3a',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  return (
    <main className="com_container p_classinfo">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_2 active">
            수업 정보
            <span className="bar"></span>
            <span className="point_txt">홍교사103ㆍ수학</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full com_sec_top_card_graph">
            <article className="wrap">
              <div className="com_board_search">
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <div className="com_status_box">
                <div className="item">
                  <p className="tit">희망 수업수</p>
                  <button className="com_btn gray xxs">수정</button>
                  <p className="num">50</p>
                </div>
                <div className="item">
                  <p className="tit">목표 수업수</p>
                  <button className="com_btn gray xxs">수정</button>
                  <p className="num">460</p>
                </div>
                <div className="item">
                  <p className="tit">진행 수업수</p>
                  <p className="num">78</p>
                </div>
                <div className="item red">
                  <p className="tit">진행률</p>
                  <p className="num">87.5%</p>
                </div>
              </div>
            </article>
            <article className="wrap">
              <div className="detail_tit dot">연간 평균 수업 수</div>
              <LineChart data={data} width={lineChartWidth} height={lineChartHeight} />
            </article>
            <article className="wrap">
              <div className="detail_tit dot">월간 평균 수업 수</div>
              <LineChart data={dataMonth} width={lineChartWidth} height={lineChartHeight} />
            </article>
          </div>
          <article className="box full">
            <div className="detail_tit dot">진행중 수업 (42)</div>
            <div className="com_board_search">
              <Tab data={tabCurrent} tab={tabCurrentIdx} setTab={setTabCurrentIdx} tabStyle="fit_cont" />
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="auto" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                </colgroup>
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>학생명</th>
                    <th>수업시간</th>
                    <th>최근 수업 일</th>
                    <th>회차 / T</th>
                    <th>진행 회차</th>
                    <th>기수</th>
                    <th>할인</th>
                    <th>시수</th>
                    <th>실 수업료</th>
                    <th>총 입금 회차</th>
                    <th>총 입금액</th>
                    <th>미 입금액</th>
                    <th>담임</th>
                    <th>수업 히스토리</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5, 6].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>준비</td>
                        <td>
                          <button className="btn_link">홍학생103</button>
                        </td>
                        <td>60분</td>
                        <td>2023, 05, 10 14:30</td>
                        <td>32/1T</td>
                        <td>12회</td>
                        <td>1기</td>
                        <td>형제할인 2%</td>
                        <td>40,000</td>
                        <td>458,000</td>
                        <td className="com_blue_txt">8.52</td>
                        <td className="com_blue_txt">645,000</td>
                        <td className="com_red_txt">54,000</td>
                        <td>
                          <button className="btn_link">김담임103</button>
                        </td>
                        <td>
                          <button className="btn_link blue">보기</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </article>
          <article className="box full">
            <div className="detail_tit dot">과거 수업내역 (78)</div>
            <section className="com_board_search">
              <Tab data={tabPrev} tab={tabPrevIdx} setTab={setTabPrevIdx} tabStyle="fit_cont" />
              <div className="com_btn_wrap">
                <button className="com_btn line gray s active">오늘</button>
                <button className="com_btn line gray s">주간</button>
                <button className="com_btn line gray s">월간</button>
              </div>
              <div className="date_wrap">
                <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                <span className="divider"> ~ </span>
                <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                <button className="com_btn gray s">조회</button>
              </div>
            </section>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="auto" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                  <col width="90" />
                </colgroup>
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>학생명</th>
                    <th>수업시간</th>
                    <th>최근 수업 일</th>
                    <th>회차 / T</th>
                    <th>진행 회차</th>
                    <th>기수</th>
                    <th>할인</th>
                    <th>시수</th>
                    <th>실 수업료</th>
                    <th>총 입금 회차</th>
                    <th>총 입금액</th>
                    <th>미 입금액</th>
                    <th>담임</th>
                    <th>수업 히스토리</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>준비</td>
                        <td>
                          <button className="btn_link">홍학생103</button>
                        </td>
                        <td>60분</td>
                        <td>2023, 05, 10 14:30</td>
                        <td>32/1T</td>
                        <td>12회</td>
                        <td>1기</td>
                        <td>형제할인 2%</td>
                        <td>40,000</td>
                        <td>458,000</td>
                        <td className="com_blue_txt">8.52</td>
                        <td className="com_blue_txt">645,000</td>
                        <td className="com_red_txt">54,000</td>
                        <td>
                          <button className="btn_link">김담임103</button>
                        </td>
                        <td>
                          <button className="btn_link blue">보기</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </article>
        </section>
      </div>
    </main>
  );
}

export default TeacherClassInfo;
